import { WbEnvironmentAccessState } from '@agilelab/plugin-wb-platform';
import { FC, ReactNode } from 'react';

type Props = {
  children?: ReactNode;
};

export const ReleaseDetailPageEnvironmentLoader: FC<Props> = ({ children }) => (
  <WbEnvironmentAccessState>{children}</WbEnvironmentAccessState>
);
